import { useGetAllUserProxiesQuery } from "@RTKQuery/user/purchases/purchases";
import style from "./TableBody.module.scss";
import { IProxy } from "@interfaces/user/proxy";
import { useAppSelector } from "store/hooks";

export function TableBody({
    children
}: {
    children: (data: IProxy) => JSX.Element
}) {
    const { activePaginationPage, activePaginationLimit, activeSortParameter, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage);

    const { data } = useGetAllUserProxiesQuery({
        page: activePaginationPage,
        limit: activePaginationLimit,
        search: activeSearchParameter,
        tag_ids: activeTags
    });

    const sortedArr = [...data?.purchases || []]

    if (activeSortParameter === "term") {
        sortedArr.sort((a, b) => {
            return (new Date(a.end_date || "").getTime() || 0) - (new Date(b.end_date || "").getTime() || 0)
        })
    }

    return (
        <div className={style.body}>
            {
                data?.purchases.map(row => children(row))
            }
        </div>
    )
}

